import type { CashierCashTransfer, CashTransferStatus } from '@/generated/graphql';

import { IAdmin, mapGQLAdmin } from './admin';
import { ICashier, mapGQLCashier } from './cashier';

export interface ICashierCashTransfer {
  id: string;
  amount: number;
  status: CashTransferStatus | string;
  createdAt: string;
  updatedAt: string;

  admin: IAdmin;
  cashier: ICashier;
}

export interface ICashierCashTransferTable {
  id: string;
  amount: number;
  status: CashTransferStatus | string;
  createdAt: string;
  cashierUsername: string;
  adminUsername: string;
}

export interface ICashierCashTransferQueryVariable {
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLCashierCashTransfer(gql_cashierCashTransfer?: CashierCashTransfer | null): ICashierCashTransfer {
  return {
    id: gql_cashierCashTransfer?.id ?? '',
    amount: gql_cashierCashTransfer ? gql_cashierCashTransfer.amount ?? 0 : 0,
    status: gql_cashierCashTransfer ? gql_cashierCashTransfer.status ?? '' : '',

    updatedAt: gql_cashierCashTransfer ? gql_cashierCashTransfer.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
    admin: mapGQLAdmin(gql_cashierCashTransfer?.admin),
    cashier: mapGQLCashier(gql_cashierCashTransfer?.cashier),
    createdAt: gql_cashierCashTransfer
      ? new Date(gql_cashierCashTransfer.createdAt).toLocaleString('en-US', {
          timeZone: 'Asia/Manila',
          month: '2-digit',
          day: '2-digit',
          year: 'numeric',
          hour12: true,
          minute: '2-digit',
          hour: '2-digit',
        }) ?? ''
      : '',
  };
}
